// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_cy-0";
export var fileCarousel = "_cy-2";
export var removeFileButton = "_cy-1";